import * as InquiryPosition from './InquiryPosition'
import * as InquiryPositionAttachment from './InquiryPositionAttachment'
import {array, Decoder, field, nullable, object} from 'json-bouncer'
import {Product, productDecoder} from './Product'

export interface InquiryPositionWithDetails {
    readonly inquiryPosition: InquiryPosition.InquiryPosition
    readonly inquiryPositionAttachments: InquiryPositionAttachment.InquiryPositionAttachment[]
    readonly product: Product | null
}

export function decoder(): Decoder<InquiryPositionWithDetails> {
    return object(
        {
            inquiryPosition:
                field('inquiryPosition', InquiryPosition.decoder()),
            inquiryPositionAttachments:
                field(
                    'inquiryPositionAttachments',
                    array(InquiryPositionAttachment.decoder())),
            product: field('product', nullable(productDecoder())),
        }
    )
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/InquiryPositionWithDetails.ts